// extracted by mini-css-extract-plugin
export default {"row":"newsList_row__P-Jfn","grid":"newsList_grid__zomot","mainInfo":"newsList_mainInfo__9c1YA","mainInfoCard":"newsList_mainInfoCard__iRGp8","flex":"newsList_flex__Oy1V9"};